import PerfectScrollbarComponent from 'react-perfect-scrollbar';
import { Box } from '@mui/material';

import { ScrollWrapperProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ScrollWrapper: React.FC<ScrollWrapperProps> = (props) => {
  const { maxHeight = '30rem', defaultScrollbar = false, children } = props;
  if (defaultScrollbar) {
    return (
      <Box sx={{ maxHeight, overflowY: 'auto', overflowX: 'hidden' }}>
        {children}
      </Box>
    );
  }
  return (
    <PerfectScrollbarComponent
      style={{ maxHeight }}
      options={{ wheelPropagation: false, suppressScrollX: true }}
    >
      {children}
    </PerfectScrollbarComponent>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default ScrollWrapper;
